import React, { useEffect, useState } from "react";
import { Check, Copy, ThumbsDown, ThumbsUp } from "lucide-react";
import { useAura } from "./AuraProvider";
import { toSpeech } from "./SimmiMarkdown";

// Copy · 👍 · 👎 under one of Simmi's replies. Ratings go to the backend with the session (the team sees which
// answers land); copying gives the plain text without markdown.
const MessageActions = ({ message, className = "" }) => {
  const { rateMessage, sessionId, t } = useAura();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(toSpeech(message.text));
      setCopied(true);
    } catch {
      /* clipboard blocked: nothing to do */
    }
  };

  const btn = "flex h-7 w-7 items-center justify-center rounded-full text-white/45 transition-colors hover:bg-white/10 hover:text-white";
  return (
    <div className={`simmi-msg-actions flex items-center gap-0.5 ${className}`}>
      <button type="button" onClick={copy} className={btn} aria-label={copied ? t.copied : t.copy} title={copied ? t.copied : t.copy}>
        {copied ? <Check className="h-3.5 w-3.5 text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}
      </button>
      {sessionId && (
        <>
          <button
            type="button"
            onClick={() => rateMessage(message, "up")}
            aria-pressed={message.rating === "up"}
            aria-label={t.helpful}
            title={t.helpful}
            className={`${btn} ${message.rating === "up" ? "text-emerald-400" : ""}`}
          >
            <ThumbsUp className="h-3.5 w-3.5" fill={message.rating === "up" ? "currentColor" : "none"} />
          </button>
          <button
            type="button"
            onClick={() => rateMessage(message, "down")}
            aria-pressed={message.rating === "down"}
            aria-label={t.notHelpful}
            title={t.notHelpful}
            className={`${btn} ${message.rating === "down" ? "text-rose-400" : ""}`}
          >
            <ThumbsDown className="h-3.5 w-3.5" fill={message.rating === "down" ? "currentColor" : "none"} />
          </button>
        </>
      )}
      {message.rating && <span className="ml-1 text-[11px] text-white/45">{t.thanksFeedback}</span>}
    </div>
  );
};

export default MessageActions;
